import { SMART_LOCK_API_ENDPOINTS } from '../URLConstants';
import SmartLockApiCallerInstance from '../utils/SmartLockApiCallerInstance';

export const GetOrganizationDetailById = async (id) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ORGANIZATION_URL}/${id}`
  );
  return response;
};

export const GetAllOrganizationList = async () => {
  const response = await SmartLockApiCallerInstance.get(
    SMART_LOCK_API_ENDPOINTS.ALL_ORGANIZATION_DATA
  );
  return response;
};

export const UpdateOrganizationDevicesSetting = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.ORGANIZATION_URL}/${id}`,
    data
  );
  return response;
};

export const GetAllOrganization = async (page, sortBy) => {
  const response = await SmartLockApiCallerInstance.get(
    `${SMART_LOCK_API_ENDPOINTS.ORGANIZATION_URL}?page=${page}&limit=10&sortField=${sortBy[0]}&sortOrder=${sortBy[1]}`
  );
  return response;
};

export const UpdateOrganizationStatus = async (id, status) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.ORGANIZATION_STATUS_UPDATE}/${id}?status=${status}`
  );
  return response;
};

export const AddOrganizationData = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.ORGANIZATION_URL,
    data
  );
  return response;
};

export const UpdateOrganizationDetailById = async (id, data) => {
  const response = await SmartLockApiCallerInstance.patch(
    `${SMART_LOCK_API_ENDPOINTS.ORGANIZATION_URL}/${id}`,
    data
  );
  return response;
};

export const OrganizationDefaultSettingById = async () => {
  const response = await SmartLockApiCallerInstance.get(
    SMART_LOCK_API_ENDPOINTS.ORGANIZATION_DEFAULT_SETTING
  );
  return response;
};

export const BulkAssignDevicesToOrganization = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.BULK_ASSIGN_DEVICE_TO_ORGANIZATION,
    data
  );
  return response;
};

export const AssignDeviceToOrganization = async (data) => {
  const response = await SmartLockApiCallerInstance.post(
    SMART_LOCK_API_ENDPOINTS.ASSIGN_DEVICE_ORG,
    data
  );
  return response;
};

export const DownloadDeviceDataFormat = async () => {
  const response = await SmartLockApiCallerInstance.get(SMART_LOCK_API_ENDPOINTS.DOWNLOAD_FORMAT, {
    responseType: 'blob'
  });
  return response;
};
